export default __webpack_public_path__ + "static/tb_helles_01-f3b0c63b1643ce1d40790298fdbe5aca.svg";